import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core'

import { FormsModule } from '@angular/forms'
import { TranslatePipe } from '@ngx-translate/core'
import { PaginatorModule } from 'primeng/paginator'

@Component({
  selector: 'app-pagination',
  standalone: true,
  imports: [FormsModule, TranslatePipe, PaginatorModule],
  templateUrl: './pagination.component.html',
  styleUrl: './pagination.component.scss'
})
export class PaginationComponent implements OnInit {
  // Inputs to make the component generic
  @Input() tableData: any
  @Input() config: any
  @Input() maxSize: number = 10 // Max page links to show
  @Input() currentLanguage = localStorage.getItem('lang')

  // Output events to notify the parent component of changes
  @Output() pageChange = new EventEmitter<number>()
  @Output() itemsPerPageChange = new EventEmitter<number>()

  public itemsPerPageModel: number | null = null

  ngOnInit(): void {
    if (this.config) {
      this.itemsPerPageModel = this.config.itemsPerPage
    }
  }

  // p-paginator emits a 0-based page; parents expect 1-based (server pageIndex).
  onPageChange(newPage: number): void {
    this.pageChange.emit(newPage)
  }

  onItemsPerPageChange(): void {
    if (this.itemsPerPageModel && this.itemsPerPageModel > 0) {
      this.itemsPerPageChange.emit(this.itemsPerPageModel)
    }
  }
}
